export default function HealthScoreGauge({ score = 0, size = 140, label = 'Health' }) {
  const radius = (size - 14) / 2;
  const circ = Math.PI * radius; // half circle
  const pct = Math.max(0, Math.min(100, score));
  const offset = circ - (pct / 100) * circ;

  const color = score >= 85 ? '#10B981' : score >= 70 ? '#3B82F6' : score >= 60 ? '#F59E0B' : score > 0 ? '#EF4444' : '#94A3B8';
  const bg = '#E2E8F0';

  const cx = size / 2;
  const cy = size / 2 + 4;

  return (
    <div className="relative flex flex-col items-center" style={{ width: size }}>
      <svg width={size} height={size / 2 + 16} viewBox={`0 0 ${size} ${size / 2 + 16}`}>
        <path
          d={`M 7 ${cy} A ${radius} ${radius} 0 0 1 ${size - 7} ${cy}`}
          stroke={bg}
          strokeWidth={12}
          fill="none"
          strokeLinecap="round"
        />
        <path
          d={`M 7 ${cy} A ${radius} ${radius} 0 0 1 ${size - 7} ${cy}`}
          stroke={color}
          strokeWidth={12}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 600ms ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
        <div className="font-mono text-3xl font-semibold text-slate-900 leading-none" data-testid="health-score-value">
          {score}
        </div>
        <div className="text-xs uppercase tracking-widest text-slate-500 mt-1">{label}</div>
      </div>
    </div>
  );
}
